import React from 'react';
import PropTypes from 'prop-types';

import { ARTICLE_CONTENT_COL_CLASSES } from 'dpl/prismic/article/utils/constants';
import Icon from 'dpl/common/components/Icon';
import { get } from 'dpl/shared/utils/object';

import {
  BREEDER_MISSION_DISPLAY_TYPE,
  GENERAL_MISSION_DISPLAY_TYPE
} from '../utils/constants';
import PrismicBreederMissionContent from './BreederMissionContent';
import PrismicBuyerMissionContent from './BuyerMissionContent';

export default function MissionCallout({ sliceData }) {
  const displayType = get(sliceData, 'primary.display_type');

  return (
    <div className="PrismicMissionCallout container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <div className="pv8 bt bb b--light-purple row">
            <div className="col-lg-9 center">
              <div className="flex justify-center">
                <div className="pr4 stone-700">
                  <Icon height="97px" name="gooddogavatar-cloud" width="78px" />
                </div>
                <div className="f2 f3-lg fw-medium">
                  {displayType === BREEDER_MISSION_DISPLAY_TYPE ? (
                    <PrismicBreederMissionContent />
                  ) : (
                    <PrismicBuyerMissionContent />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

MissionCallout.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      display_type: PropTypes.oneOf([
        BREEDER_MISSION_DISPLAY_TYPE,
        GENERAL_MISSION_DISPLAY_TYPE
      ])
    })
  }).isRequired
};
